import { render, staticRenderFns } from "./JobTaskSection.vue?vue&type=template&id=6027cd1a&scoped=true&"
import script from "./JobTaskSection.vue?vue&type=script&lang=js&"
export * from "./JobTaskSection.vue?vue&type=script&lang=js&"
import style0 from "./JobTaskSection.vue?vue&type=style&index=0&id=6027cd1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6027cd1a",
  null
  
)

export default component.exports